import React from 'react';

import type CK from '~/types/contentking';

import usePendoContext from './usePendoContext';



function useTrackIgnoringUpdateInPendo() {
	const pendo = usePendoContext();

	return React.useCallback(
		(websiteId: CK.WebsiteId, issueName: string, newStatus: boolean, scope: string) => {
			const message = newStatus
				? 'Issue ignored'
				: 'Issue un-ignored';

			pendo.trackEvent(message, {
				'Website ID': websiteId,
				'Issue name': issueName,
				'Scope': scope,
			});
		},
		[
			pendo,
		],
	);
}



export default useTrackIgnoringUpdateInPendo;
